export const previewer = state => state;

export default previewer;
